// store.ts

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import filtersReducer from './reducers/filter-settings/filterSlice';  // Importez votre reducer pour filterDate ici
import {
  auth,
  media,
  social,
  resources,
  metrics,
  workspaces,
  csrf,
  dashboard,
  admin,
  businessOverview,
  brandOverview,
  countries,
  competitorsMonitoring,
  liveBidding,
  campaignExplorer,
  sso,
  onboard,
  cockpit,
  conversionsAnalysis,
  competitiveIntelligence,
  activations,
  googleAPI,
  filters,
  extAPI,
  jobsAPI,
  tagAPI,
  currencies,
  exports
} from './api';

import { appSettings } from './reducers';
import adsUiReducer from './reducers/competitive-intelligence/adsSlice';
import { performance } from './api/performance/api';
import { dataApi } from './api/data/api';
import nonBrandedAPI from './api/non-branded/api';


export const apiState = {
  [auth.reducerPath]: auth,
  [media.reducerPath]: media,
  [social.reducerPath]: social,
  [metrics.reducerPath]: metrics,
  [resources.reducerPath]: resources,
  [workspaces.reducerPath]: workspaces,
  [performance.reducerPath]: performance,
  [liveBidding.reducerPath]: liveBidding,
  [csrf.reducerPath]: csrf,
  [businessOverview.reducerPath]: businessOverview,
  [brandOverview.reducerPath]: brandOverview,
  [competitorsMonitoring.reducerPath]: competitorsMonitoring,
  [campaignExplorer.reducerPath]: campaignExplorer,
  [admin.reducerPath]: admin,
  [dashboard.reducerPath]: dashboard,
  [countries.reducerPath]: countries,
  [sso.reducerPath]: sso,
  [onboard.reducerPath]: onboard,
  [dataApi.reducerPath]: dataApi,
  [cockpit.reducerPath]: cockpit,
  [conversionsAnalysis.reducerPath]: conversionsAnalysis,
  [competitiveIntelligence.reducerPath]: competitiveIntelligence,
  [googleAPI.reducerPath]: googleAPI,
  [activations.reducerPath]: activations,
  [filters.reducerPath]: filters,
  [extAPI.reducerPath]: extAPI,
  [jobsAPI.reducerPath]: jobsAPI,
  [nonBrandedAPI.reducerPath]: nonBrandedAPI,
  [tagAPI.reducerPath]: tagAPI,
  [currencies.reducerPath]: currencies,
  [exports.reducerPath]: exports
}

const reducer = combineReducers(Object.assign({},
  Object.entries(apiState).reduce((acc, [key, value]) => ({ ...acc, [key]: value.reducer }), {} as Record<keyof typeof apiState, typeof apiState[keyof typeof apiState]['reducer']>),
  {
    appSettings: appSettings, // Propriété 2
    filters: filtersReducer,  // Propriété 3
    competitiveIntelligenceAdsUi: adsUiReducer,
  }
)
);

const store = configureStore({
  reducer,
  middleware: (defaultMiddleware) =>
    defaultMiddleware().concat([
      auth.middleware,
      media.middleware,
      social.middleware,
      metrics.middleware,
      resources.middleware,
      workspaces.middleware,
      performance.middleware,
      csrf.middleware,
      countries.middleware,
      admin.middleware,
      campaignExplorer.middleware,
      businessOverview.middleware,
      brandOverview.middleware,
      competitorsMonitoring.middleware,
      liveBidding.middleware,
      dashboard.middleware,
      sso.middleware,
      onboard.middleware,
      cockpit.middleware,
      googleAPI.middleware,
      dataApi.middleware,
      conversionsAnalysis.middleware,
      competitiveIntelligence.middleware,
      activations.middleware,
      filters.middleware,
      extAPI.middleware,
      competitiveIntelligence.middleware,
      jobsAPI.middleware,
      nonBrandedAPI.middleware,
      tagAPI.middleware,
      currencies.middleware,
      exports.middleware
    ]),
});

export default store;
export type RootState = ReturnType<typeof reducer>;
export type ApiState = typeof apiState;
